export const LABEL_KINDS = ["location"] as const;
export type LabelKind = (typeof LABEL_KINDS)[number];

export const DEFAULT_BAND_COLOR = "#F5D76E";
